import { TFunction } from "i18next";
import { CollectionMethod } from "../models/CollectionMethod";

/** The method's name in the UI language ("SEPA direct debit", "Card on file"). */
export const methodLabel = (method: CollectionMethod, t: TFunction): string =>
  method === CollectionMethod.SepaDebit ? t("collection.method.sepa") : t("collection.method.card");

/** The methods joined for one sentence: "SEPA direct debit, Card on file". */
export const methodsLabel = (methods: CollectionMethod[], t: TFunction): string =>
  methods.map((method) => methodLabel(method, t)).join(", ");
